/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleNumber1 = createReactComponent("outline", "circle-number-1", "IconCircleNumber1", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

export { IconCircleNumber1 as default };
//# sourceMappingURL=IconCircleNumber1.mjs.map
